import { Injector } from '@angular/core';
import { AbstractTool2D } from '../../shared/tools/shared/abstract-tool-2d';
import { ImageContentState } from '../state/image-content-state';
import { ImageContentStore } from '../state/image-content-store';

export abstract class AbstractRasterCodingTool extends AbstractTool2D<
  ImageContentState,
  ImageContentStore
> {
  protected constructor(injector: Injector) {
    super(injector);
  }

  protected getCode(mouseDownEvent: MouseEvent) {
    const selectedCode = this.store.state().selectedTagOptionCode;
    return mouseDownEvent.altKey ? 0 : selectedCode;
  }
}
